import { APP_FONT_SIZE } from '../../theme.constant'
import { BeforeConvertingToRemPxUnit } from '../../../model/CssUnit'
import { genericTypographyStyles } from './base-typography'
import { Theme } from '@mui/material'
import { deepmerge } from '@mui/utils'
import { getIdentity } from '../../../../../util/helper'

export const h1FontSize = getIdentity<BeforeConvertingToRemPxUnit>(30)

export const h2FontSize = getIdentity<BeforeConvertingToRemPxUnit>(24)

export const h3FontSize = getIdentity<BeforeConvertingToRemPxUnit>(20)

export const h4FontSize = getIdentity<BeforeConvertingToRemPxUnit>(18)

export const h5FontSize = getIdentity<BeforeConvertingToRemPxUnit>(16)

export const h6FontSize = getIdentity<BeforeConvertingToRemPxUnit>(14)

export const body1FontSize = getIdentity<BeforeConvertingToRemPxUnit>(14)

export const body2FontSize = getIdentity<BeforeConvertingToRemPxUnit>(13)

export const subtitle1FontSize = getIdentity<BeforeConvertingToRemPxUnit>(16)

export const subtitle2FontSize = getIdentity<BeforeConvertingToRemPxUnit>(14)

export const captionFontSize = getIdentity<BeforeConvertingToRemPxUnit>(12)

export const buttonFontSize = getIdentity<BeforeConvertingToRemPxUnit>(14)

export const overlineFontSize = getIdentity<BeforeConvertingToRemPxUnit>(11)

export const overrideTypography = (theme: Theme) => {
  return deepmerge(theme, {
    typography: {
      fontSize: APP_FONT_SIZE,
      ...genericTypographyStyles,
      h1: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h1FontSize),
        fontWeight: 700,
        lineHeight: 1.167,
      },
      h2: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h2FontSize),
        fontWeight: 600,
        lineHeight: 1.2,
      },
      h3: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h3FontSize),
        fontWeight: 600,
        lineHeight: 1.167,
      },
      h4: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h4FontSize),
        fontWeight: 500,
        lineHeight: 1.235,
      },
      h5: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h5FontSize),
        fontWeight: 500,
        lineHeight: 1.334,
      },
      h6: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(h6FontSize),
        fontWeight: 500,
        lineHeight: 1.6,
      },
      body1: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(body1FontSize),
        fontWeight: 400,
        lineHeight: 1.5,
      },
      body2: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(body2FontSize),
        fontWeight: 400,
        lineHeight: 1.43,
      },
      subtitle1: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(subtitle1FontSize),
        fontWeight: 500,
        lineHeight: 1.75,
      },
      subtitle2: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(subtitle2FontSize),
        fontWeight: 500,
        lineHeight: 1.57,
      },
      caption: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(captionFontSize),
        fontWeight: 400,
        lineHeight: 1.66,
        color: theme.palette.text.primary,
      },
      button: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(buttonFontSize),
        fontWeight: 500,
        lineHeight: 1.75,
        textTransform: 'unset',
      },
      overline: {
        ...genericTypographyStyles,
        fontSize: theme.handleCssUnit(overlineFontSize),
        fontWeight: 400,
        lineHeight: 2.66,
      },
    },
  })
}
